export default __webpack_public_path__ + "static/media/GLNVR.400b8020.png";